module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rochelle Alers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Hailed by readers and booksellers alike as one of today's most popular African-American authors of women's fiction, Ms. Alers is a regular on bestsellers list, and has been a recipient of numerous awards, including the Vivian Stephens Award for Excellence in Romance Writing and a Zora Neale Hurston Literary Award.  Visit her Web site "), _c('a', {
    attrs: {
      "href": "http://www.rochellealers.com"
    }
  }, [_vm._v("www.rochellealers.com")]), _c('Br', [_c('Br', [_vm._v(" ")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NKxVIZ/tc-custom/9781459215382.jpg?1740470417850",
      "alt": "This image is the cover for the book Capital Wives"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Capital Wives\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Three D.C. wives become friends as they weather the storms in their tumultuous lives in this dramatic novel.")]), _c('br'), _c('br'), _vm._v("Married to some of Washington, D.C.’s most influential men, Bethany, Deanna and Marisol are on the guest list at every high-profile political and social event. And when they meet at a fundraiser, they forge a deep, unexpected friendship."), _c('br'), _c('br'), _vm._v("Beneath the glamour, all three are struggling to hide the void in their marriages. Bethany’s teenage stepdaughter is wreaking chaos at home, and to escape, Bethany begins writing an anonymous, dirt-dishing gossip column. Deanna is a successful event planner, longing for a baby and unaware of her husband’s double life. Marisol, too, is desperate to start a family, and starting to question her husband’s commitment, and her own."), _c('br'), _c('br'), _vm._v("As their friendship deepens, Bethany, Marisol and Deanna help each other decide how far they’ll go to fulfill their desires. Because in passion—as in politics—one mistake can change everything . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0